import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";

gsap.registerPlugin(ScrollTrigger);

if (document.querySelector('.hero-images')) {

ScrollTrigger.matchMedia({
"(min-width: 800px)": function() {

let heroImagesContainer = '.hero-images'

    window.onload = function() {

      let heroImagesTimeline = gsap.timeline();

      let heroImage1 = '.hero-images__1'
      let heroImage2 = '.hero-images__2'
      let heroImage3 = '.hero-images__3'
      let heroImage4 = '.hero-images__4'
      let heroImage5 = '.hero-images__5'
      let heroImage6 = '.hero-images__6'


      heroImagesTimeline
        .from(heroImage1, {duration: 1, x: -100, opacity: 0})
        .from(heroImage2, {duration: 1, x: -100, opacity: 0}, "-=.5")
        .from(heroImage3, {duration: 1, x: -100, opacity: 0}, "-=.5")
        .from(heroImage4, {duration: 1, x: -100, opacity: 0}, "-=.5")
        .from(heroImage5, {duration: 1, x: -100, opacity: 0}, "-=.5")
        .from(heroImage6, {duration: 1, x: -100, opacity: 0}, "-=.5");


      gsap.to(".hero-images__landscape", {
        yPercent: 100,
        ease: "none",
        scrollTrigger: {
          trigger: heroImagesContainer,
          start: "20%",
          scrub: true
        }, 
      });

      gsap.to(".hero-images__portrait", {
        yPercent: -50,
        ease: "none",
        scrollTrigger: {
          trigger: heroImagesContainer,
          start: "10%",
          scrub: true
        }, 
      });

    }

}};


}